import { useEffect, useState } from 'react'
import { personalRecords, type PersonalRecord } from '@/db/queries'

export default function RecordsStrip() {
  const [records, setRecords] = useState<PersonalRecord[]>([])

  useEffect(() => {
    personalRecords().then(setRecords)
  }, [])

  if (!records.length) return null

  return (
    <section>
      <div className="flex items-baseline justify-between mb-3">
        <h2 className="text-sm uppercase tracking-wider text-stone-500">
          Personal records
        </h2>
        <span className="text-[11px] text-stone-400">all time</span>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
        {records.map((r) => (
          <div
            key={r.key}
            className="rounded-xl border border-stone-200 bg-white p-4 shadow-sm"
          >
            <div className="text-[11px] uppercase tracking-wider text-stone-500">
              {r.label}
            </div>
            <div className="mt-1.5 text-2xl font-semibold tabular-nums text-stone-900">
              {r.formatted}
            </div>
            <div className="mt-1 text-[11px] text-stone-500">{formatDate(r.day)}</div>
          </div>
        ))}
      </div>
    </section>
  )
}

function formatDate(iso: string): string {
  if (!iso) return ''
  const d = new Date(iso + 'T12:00:00')
  return d.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}
